import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildRuin: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const corners: { x: number; z: number; height: number }[] = [
        { x: 0, z: 0, height: 6 },
        { x: 6, z: 0, height: 5 },
        { x: 0, z: 6, height: 4 },
        { x: 6, z: 6, height: 6 },
    ];

    for (const corner of corners) {
        brush.column(corner.x, corner.z, 0, corner.height - 1, BLOCK.Stone);
    }

    const perimeter: [number, number][] = [
        [1, 0],
        [3, 0],
        [5, 0],
        [0, 3],
        [0, 5],
        [6, 2],
        [6, 4],
        [2, 6],
        [4, 6],
    ];
    for (const [dx, dz] of perimeter) {
        const height = 1 + ((dx * 7 + dz * 11) % 3);
        brush.column(dx, dz, 0, height - 1, BLOCK.Stone);
    }

    brush.block(2, 0, 3, BLOCK.Rock);
    brush.block(4, 0, 2, BLOCK.Rock);
    brush.block(3, 0, 5, BLOCK.Rock);
};
